/**
 * Stable CSS class names for E2E — SearchService page.
 */
export const SS = {
    page: 'search-service-page',

    progressSection: 'search-service-page__progress-section',
    progressBar: 'search-service-page__progress-bar',

    modalSection: 'search-service-page__batch-modal-section',

    productDrawerPaper: 'search-service-page__product-drawer-paper',
    productDrawerContent: 'search-service-page__product-drawer-content',
    stockDrawerPaper: 'search-service-page__stock-drawer-paper',
    stockDrawerContent: 'search-service-page__stock-drawer-content',

    breadcrumbSection: 'search-service-page__breadcrumb-section',
    actionsRow: 'search-service-page__actions-row',

    searchFieldWrap: 'search-service-page__search-field-wrap',
    searchFieldPaper: 'search-service-page__search-field-paper',
    searchFieldSelect: 'search-service-page-input__search-type-select',
    searchFieldInput: 'search-service-page-input__search-key-input',
    searchFieldIconButton: 'search-service-page-input__search-submit-icon',

    batchSearchButton: 'search-service-page-input--button-batch-search',
    excelDownloadButton: 'search-service-page-input--button-download-excel',
    excelDownloadIcon: 'search-service-page__download-excel-icon',

    dataGridSection: 'search-service-page__data-grid-section',
    dataGridWrap: 'search-service-page__data-grid-wrap',
    noRecordWrap: 'search-service-page__no-record-wrap',

    cellSearchKey: 'search-service-page__cell-search-key',
    cellOptionIdChip: 'search-service-page__cell-option-id-chip',

    cellSearchProductButton: 'search-service-page-input--button-search-product',
    cellSearchProductIcon: 'search-service-page__search-product-icon',

    cellSearchStockButton: 'search-service-page-input--button-search-stock',
    cellSearchStockIcon: 'search-service-page__search-stock-icon',
} as const;

export const ssCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

